import React, { useEffect, useRef, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./dropoff-location-field.css";

const RIYADH = { lat: 24.7136, lng: 46.6753 };

function DropoffLocationMap({ target, onUserMove }) {
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const onUserMoveRef = useRef(onUserMove);
  const suppressRef = useRef(0);
  const [lifted, setLifted] = useState(false);

  onUserMoveRef.current = onUserMove;

  useEffect(() => {
    const el = containerRef.current;
    if (!el || mapRef.current) return undefined;

    const map = L.map(el, { zoomControl: true, attributionControl: true });
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      attribution: "&copy; OpenStreetMap contributors",
    }).addTo(map);

    map.on("movestart", () => setLifted(true));
    map.on("moveend", () => {
      setLifted(false);
      if (suppressRef.current > 0) {
        suppressRef.current -= 1;
        return;
      }
      const center = map.getCenter();
      onUserMoveRef.current(center.lat, center.lng);
    });

    suppressRef.current += 1;
    map.setView([RIYADH.lat, RIYADH.lng], 12);
    mapRef.current = map;

    const resizeTimer = setTimeout(() => map.invalidateSize(), 320);
    return () => {
      clearTimeout(resizeTimer);
      map.remove();
      mapRef.current = null;
    };
  }, []);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    if (!target) {
      const center = map.getCenter();
      if (
        Math.abs(center.lat - RIYADH.lat) < 1e-6 &&
        Math.abs(center.lng - RIYADH.lng) < 1e-6 &&
        map.getZoom() === 12
      ) {
        return;
      }
      suppressRef.current += 1;
      map.setView([RIYADH.lat, RIYADH.lng], 12);
      return;
    }
    const center = map.getCenter();
    const zoom = target.zoom != null ? target.zoom : map.getZoom();
    if (
      Math.abs(center.lat - target.lat) < 1e-6 &&
      Math.abs(center.lng - target.lng) < 1e-6 &&
      map.getZoom() === zoom
    ) {
      return;
    }
    suppressRef.current += 1;
    map.setView([target.lat, target.lng], zoom);
  }, [target]);

  return (
    <div className={`dlf__map-wrap${lifted ? " is-lifted" : ""}`} dir="ltr">
      <div ref={containerRef} className="dlf__map" />
      <svg className="dlf__pin" viewBox="0 0 34 46" aria-hidden="true">
        <path
          d="M17 0C7.6 0 0 7.6 0 17c0 12.8 17 29 17 29s17-16.2 17-29C34 7.6 26.4 0 17 0z"
          fill="#dc2626"
        />
        <circle cx="17" cy="17" r="6.5" fill="#fff" />
      </svg>
      <div className="dlf__pin-shadow" />
    </div>
  );
}

export default DropoffLocationMap;
